import { useState, useEffect } from 'react';

let globalStepName = '';
const listeners = new Set();

/**
 * Updates the global analytics step name and notifies all listening components.
 * @param {string} name - The new step name (e.g. 'Evacuation_Location').
 */
export const setAnalyticsStepName = (name) => {
    if (globalStepName === name) return; 
    globalStepName = name;
    listeners.forEach((listener) => listener(globalStepName));
};

/**
 * Custom hook to subscribe to the global analytics step name.
 * Triggers a re-render whenever the step name changes.
 * @returns {string} The current step name.
 */
export const useAnalyticsStep = () => {
    const [stepName, setStepName] = useState(globalStepName);

    useEffect(() => {
        const handleUpdate = (newName) => setStepName(newName);
        listeners.add(handleUpdate);
        return () => {
            listeners.delete(handleUpdate);
        };
    }, []);

    return stepName;
};